import React from "react";

interface FormFieldProps {
  label: string;
  name: string;
  value: string;
  type?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  options?: string[];
  className?: string;
  variant?: "cases" | "smile" | "uris";
}

const FormField: React.FC<FormFieldProps> = ({
  label,
  name,
  value,
  onChange,
  type = "text",
  options,
  className = "",
  variant = "cases",
}) => {
  const isSmile = variant === "smile";
  const isUris = variant === "uris";

  const labelClass = isUris
    ? "w-full md:w-1/3 text-sm md:text-md text-[#c5c7cc] font-medium"
    : isSmile
    ? "w-full md:w-1/3 text-sm md:text-md text-[#c7ccca] font-medium"
    : "w-full md:w-1/3 text-sm md:text-md text-gray-700 font-medium";

  const controlClass = isUris
    ? "border w-full md:px-2 py-1 md:w-2/3 text-sm md:text-md rounded-md bg-[#141517] border-[#3a3c42] text-white focus:outline-none focus:border-[#c31c30]"
    : isSmile
    ? "border-2 w-full md:px-2 py-1 md:w-2/3 text-sm md:text-md rounded-sm bg-[#141716] border-[#1f2221] text-white focus:outline-none focus:border-cyan-400"
    : "border-2 w-full md:px-2 py-1 md:w-2/3 text-sm md:text-md rounded-sm focus:outline-none focus:border-[#2fa9bf]";

  return (
    <div className={`flex items-center mb-2 md:mb-3 w-full md:w-[80%] ${className}`}>
      <label className={labelClass}>{label}</label>
      {options ? (
        <select
          name={name}
          value={value}
          onChange={onChange}
          className={`${controlClass} cursor-pointer`}
        >
          <option
            value=""
            className={
              isUris
                ? "bg-[#141517] text-white"
                : isSmile
                  ? "bg-[#141716] text-white"
                  : ""
            }
          >
            Select
          </option>
          {options.map((opt) => (
            <option
              key={opt}
              value={opt}
              className={
                isUris
                  ? "bg-[#141517] text-white"
                  : isSmile
                    ? "bg-[#141716] text-white"
                    : ""
              }
            >
              {opt}
            </option>
          ))}
        </select>
      ) : (
        <input
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          className={controlClass}
        />
      )}
    </div>
  );
};

export default FormField;
